import React from 'react';

interface ISwitch {
    checked: boolean;
    beforeIcon?: string;
    onToggleSwitch: () => void;
    beforeText?: string;
    afterText?: string;
    dataQa?: string;
}

const Switch = ({ checked, beforeText, afterText, dataQa, beforeIcon, onToggleSwitch }: ISwitch) => {
    return (
        <div data-qa={dataQa || ''} className="flex flex-row items-center justify-between">
            <div className="flex flex-row items-center">
                {beforeIcon && (
                    <img src={beforeIcon} className="w-[17px] object-contain mr-3" />
                )}
                {beforeText && (
                    <span className="mr-3 text-sm font-medium text-black dark:text-gray-200">
                        {beforeText}
                    </span>
                )}
            </div>

            <div onClick={onToggleSwitch} className="inline-flex relative items-center cursor-pointer">
                <input
                    type="checkbox"
                    value=""
                    className="sr-only peer"
                    checked={checked}
                    readOnly
                />
                <div
                    className="
                        w-11 h-6 
                        bg-gray-200 
                        rounded-full 
                        peer 
                        peer-focus:ring-4 
                        peer-focus:ring-[#F7931E]/30
                        dark:peer-focus:ring-[#F7931E]/80
                        peer-checked:after:translate-x-full 
                        peer-checked:after:border-white 
                        after:content-[''] 
                        after:absolute 
                        after:top-0.5 
                        after:left-[2px] 
                        after:bg-white 
                        after:border-gray-300 
                        after:border 
                        after:rounded-full 
                        after:h-5 
                        after:w-5 
                        after:transition-all 
                        dark:border-gray-900
                        peer-checked:bg-black 
                        dark:peer-checked:bg-[#00330F]
                    "
                ></div>
            </div>

            {afterText && (
                <span className="ml-3 text-sm font-medium text-black dark:text-gray-200">
                    {afterText}
                </span>
            )}
        </div>
    );
};

export default Switch;
